import type {ReactElement} from 'react';
import React from 'react';
import {BaseListColorPanel} from '@Components/poster-editor/components/poster-editing-side-panel/components/base-list-color-panel';
import type {RGBA} from '@Utils/color.util';
import {getFillTypeFromColorFillType} from '@Utils/color.util';
import type {ColorFillPropertyType} from '@Components/color-fill';
import {useSingleActivePosterItemId} from '@Hooks/poster-editor/useSingleActivePosterItemId';
import {useGetSelectedSlideId} from '@Hooks/poster-editor/useGetSelectedSlideId';
import {useGetKeyFromFillOfListOfActiveSlideItem} from '@Hooks/poster-editor/useGetKeyFromFillOfListOfActiveSlideItem';
import {useGetKeyFromListOfActiveSlideItem} from '@Hooks/poster-editor/useGetKeyFromListOfActiveSlideItem';

export function TextSlideListColorPanel(): ReactElement<any> {
  const activeItemId = useSingleActivePosterItemId();
  const activeItem = activeItemId ? window.posterEditor?.whiteboard?.getItemForId(activeItemId) : undefined;
  const activeSlideUID = useGetSelectedSlideId();
  const activeSlide = activeSlideUID && activeItem?.isSlideshow() ? activeItem.getSelectedSlide() : null;
  const fillColor = useGetKeyFromFillOfListOfActiveSlideItem('fillColor');
  const fillType = useGetKeyFromFillOfListOfActiveSlideItem('fillType');
  const listType = useGetKeyFromListOfActiveSlideItem('type');
  const listStyle = useGetKeyFromListOfActiveSlideItem('style');
  const listWidth = useGetKeyFromListOfActiveSlideItem('width');

  if (!activeItem?.isSlideshow()) {
    throw new Error(`Expected slideshow item but got ${activeItem?.gitype}`);
  }

  if (!activeSlideUID || !activeSlide?.isTextSlide()) {
    throw new Error('unable to get the selected text slide');
  }

  if (!fillColor || fillType === undefined || listType === undefined || listStyle === undefined || listWidth === undefined) {
    throw new Error('unable to get the list properties for text slide');
  }

  const updateFillColor = (fillColor: RGBA[], undoable = true): void => {
    void activeItem.updateSlideFromObject(
      activeSlideUID,
      {
        list: {
          fill: {
            fillColor,
          },
        },
      },
      {
        undoable,
      }
    );
  };

  const onChangeType = (newType: ColorFillPropertyType): void => {
    void activeItem.updateSlideFromObject(activeSlideUID, {
      list: {
        fill: {
          fillType: getFillTypeFromColorFillType(newType),
          fillColor: activeSlide.list.fill.getColorForNewType(getFillTypeFromColorFillType(newType)),
        },
      },
    });
  };

  return (
    <BaseListColorPanel
      list={{
        type: listType,
        fill: {
          fillType: fillType,
          fillColor: fillColor,
        },
        style: listStyle,
        width: listWidth,
      }}
      updateFillColor={updateFillColor}
      onChangeType={onChangeType}
    />
  );
}
